// extracted by mini-css-extract-plugin
export default {"label":"InputLabel_label__3+YIu"};